import React from "react";
import { appColors, appType } from "../../utils/appTheme";
import AppButton from "./AppButton";

/**
 * Estado vacío al estilo app: círculo de 70px con icono, título y subtítulo.
 * action: { label, onClick } opcional.
 */
const AppEmptyState = ({ icon, title, description, action, style }) => (
  <div
    style={{
      textAlign: "center",
      padding: "56px 24px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 14,
      ...style,
    }}
  >
    {icon && (
      <span
        style={{
          width: 70,
          height: 70,
          borderRadius: "50%",
          border: `1px solid ${appColors.line}`,
          color: appColors.ink3,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 28,
        }}
      >
        {icon}
      </span>
    )}
    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
      {title && <span style={{ ...appType.cardTitle }}>{title}</span>}
      {description && (
        <span style={{ ...appType.body, color: appColors.ink2, maxWidth: 280 }}>
          {description}
        </span>
      )}
    </div>
    {action && (
      <AppButton variant="primary" onClick={action.onClick}>
        {action.label}
      </AppButton>
    )}
  </div>
);

export default AppEmptyState;
